export const COLLECTION_PATH_USERS = "users"

export interface AuthUser {
  id: string;
  email: string;
  initials: string;
  displayName: string;
  mobile: string;
  avatarUrl?: string;
  isEmailVerified: boolean;
  defaultLocationId?: string;
  isVerifiedForSegment:{ [segmentId: string]: boolean };
  preferences: any;
  lastLogin: number;
}

export const COLLECTION_PATH_INVITES = "invites";

export interface UserInvite {
  id?: string
  email: string
  message?: string
  invitedToSegmentId: string
  invitedToLocationId: string
  createdAt: number
  expiresAt: number
  isActive: boolean
  invitedById: string
  invitedBy: string
  invitedByImageURL?: string
  respondedAt?: number
  accepted?: boolean
}

export interface UserInvitations {
  invites: {[locationId: string]: UserInvite}
  email: string
  invitedByLocations: {[invitedById: string]: string[]}
}
